module.exports = __webpack_public_path__ + "media/newstyle/images/logo-cda-e4d38fc7c8ca395239093f901c91ae5a.svg";